module.exports = __webpack_public_path__ + "img/punch-out.82cd9df2.png";